import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ac019484"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "card-fund" };
const _hoisted_2 = { class: "desc" };
const _hoisted_3 = { class: "card-image" };
const _hoisted_4 = { class: "container-fund" };
const _hoisted_5 = { class: "grid-container" };
const _hoisted_6 = { class: "item1" };
const _hoisted_7 = { class: "item2" };
const _hoisted_8 = { class: "green" };
const _hoisted_9 = { class: "grid-container" };
const _hoisted_10 = { class: "item1" };
const _hoisted_11 = { class: "item2" };
const _hoisted_12 = { class: "green" };
const _hoisted_13 = { class: "grid-container" };
const _hoisted_14 = { class: "item1" };
const _hoisted_15 = { class: "item2" };
const _hoisted_16 = { class: "green" };
const _hoisted_17 = { class: "grid-container" };
const _hoisted_18 = { class: "item1" };
const _hoisted_19 = { class: "item2" };
const _hoisted_20 = { class: "green" };
const _hoisted_21 = {
    key: 0,
    class: "grid-container"
};
const _hoisted_22 = { class: "item1" };
const _hoisted_23 = { class: "item2" };
import CryptoIcon from '@/materials/atoms/CryptoIcon.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        fund: null
    },
    setup(__props) {
        const data = __props;
        const { format, STAKING_LIST_TITLES, STAKING_FUND_LABELS, STAKING_LIST_CONTENT } = useMessage();
        const FREE_PLAN = 1;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(format)(_unref(STAKING_LIST_TITLES).STAKING_LIST)), 1),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(CryptoIcon, {
                        class: "crypto_icon",
                        base: data.fund.cryptoName,
                        width: 50
                    }, null, 8, ["base"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(format)(_unref(STAKING_FUND_LABELS).PLAN)), 1),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", _hoisted_8, _toDisplayString(data.fund.term == FREE_PLAN
                                ? _unref(format)(_unref(STAKING_LIST_CONTENT).FREE) + _unref(format)(_unref(STAKING_LIST_CONTENT).PLAN)
                                : data.fund.term + _unref(format)(_unref(STAKING_LIST_CONTENT).REMAINING_DAYS)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(format)(_unref(STAKING_FUND_LABELS).RATE)), 1),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", _hoisted_12, _toDisplayString(data.fund.interestRate + _unref(format)(_unref(STAKING_LIST_CONTENT).PERCENT)), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(format)(_unref(STAKING_FUND_LABELS).AMOUNT)), 1),
                        _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("span", _hoisted_16, _toDisplayString(data.fund.amount + data.fund.cryptoName.toUpperCase()), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(format)(_unref(STAKING_FUND_LABELS).INTEREST)), 1),
                        _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(data.fund.term == FREE_PLAN ? '--' : data.fund.scheduledInterest + data.fund.cryptoName.toUpperCase()), 1)
                        ])
                    ]),
                    (data.fund.term !== FREE_PLAN)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(format)(_unref(STAKING_FUND_LABELS).DATE)), 1),
                            _createElementVNode("div", _hoisted_23, _toDisplayString(data.fund.maturityDate), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
